import { useMemo } from 'react';

import { useQueries } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';

export const vendorQueryKeys = {
  all: ['vendors'] as const,
  details: () => [...vendorQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...vendorQueryKeys.details(), id] as const,
};

export function useGetVendorsByIds(vendorIds: Array<string>) {
  const queries = useQueries({
    queries: vendorIds.map((id) => ({
      queryKey: vendorQueryKeys.detail(id),
      queryFn: () => VendorsService.getVendorById(id),
      enabled: !!id,
      staleTime: 5 * 60 * 1000,
    })),
  });

  const isLoading = queries.some((q) => q.isLoading);
  const isError = queries.some((q) => q.isError);

  const vendorMap = useMemo(() => {
    const map = new Map<string, any>();
    vendorIds.forEach((id, index) => {
      const query = queries[index];
      if (query?.data?.result) {
        map.set(id, query.data.result);
      }
    });
    return map;
  }, [vendorIds, queries]);

  return { vendorMap, isLoading, isError };
}
